<template>
  <div class="owner-detail-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('ownerDetail.page.title')" :subtitle="$t('ownerDetail.page.subtitle')">
      <template #extra>
        <el-button v-if="ownerDetailInfo.needBack" icon="el-icon-back" @click="$router.go(-1)">
          {{ $t('common.back') }}
        </el-button>
        <el-button type="primary" icon="el-icon-edit" @click="_openEditOwnerDetailModel">
          {{ $t('common.edit') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- (2) 业主信息面板 -->
    <div class="ds-panel ds-panel--padded">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('ownerDetail.ownerInfo') }}</span>
      </div>

      <el-row :gutter="16">
        <el-col :xs="24" :sm="24" :md="4" :lg="3">
          <div class="text-center owner-detail-avatar">
            <img v-if="ownerDetailInfo.faceUrl" width="120px" height="140px" class="border-radius"
              :src="ownerDetailInfo.faceUrl" @error="errorLoadImg" />
            <img v-else width="120px" height="140px" class="border-radius" src="/img/noPhoto.jpg" />
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="20" :lg="21">
          <div class="ds-info-grid">
            <div class="ds-info-grid__item">
              <span class="ds-info-grid__label">{{ $t('ownerDetail.ownerId') }}</span>
              <span class="ds-info-grid__value ds-num">{{ ownerDetailInfo.ownerId || '-' }}</span>
            </div>
            <div class="ds-info-grid__item">
              <span class="ds-info-grid__label">{{ $t('ownerDetail.name') }}</span>
              <span class="ds-info-grid__value">{{ ownerDetailInfo.name || '-' }}</span>
            </div>
            <div class="ds-info-grid__item" v-if="ownerDetailInfo.personType == 'P'">
              <span class="ds-info-grid__label">{{ $t('ownerDetail.gender') }}</span>
              <span class="ds-info-grid__value">
                {{ ownerDetailInfo.sex == '0' ? $t('common.male') : (ownerDetailInfo.sex == '1' ?
                  $t('common.female')
                  : '') }}
              </span>
            </div>
            <div class="ds-info-grid__item">
              <span class="ds-info-grid__label">{{ $t('ownerDetail.personType') }}</span>
              <span class="ds-info-grid__value">{{ ownerDetailInfo.personTypeName || '-' }}</span>
            </div>
            <div class="ds-info-grid__item">
              <span class="ds-info-grid__label">{{ $t('ownerDetail.personRole') }}</span>
              <span class="ds-info-grid__value">{{ ownerDetailInfo.personRoleName || '-' }}</span>
            </div>
            <div class="ds-info-grid__item">
              <span class="ds-info-grid__label">{{ $t('ownerDetail.idCard') }}</span>
              <span class="ds-info-grid__value ds-num">{{ ownerDetailInfo.idCard || '-' }}</span>
            </div>
            <div class="ds-info-grid__item">
              <span class="ds-info-grid__label">{{ $t('ownerDetail.contact') }}</span>
              <span class="ds-info-grid__value ds-num">{{ ownerDetailInfo.link || '-' }}</span>
            </div>
            <div class="ds-info-grid__item">
              <span class="ds-info-grid__label">{{ $t('ownerDetail.backupPhone') }}</span>
              <span class="ds-info-grid__value ds-num">{{ ownerDetailInfo.concactLink || '-' }}</span>
            </div>
            <div class="ds-info-grid__item" v-if="ownerDetailInfo.personType == 'C'">
              <span class="ds-info-grid__label">{{ $t('ownerDetail.contactPerson') }}</span>
              <span class="ds-info-grid__value">{{ ownerDetailInfo.concactPerson || '-' }}</span>
            </div>
            <div class="ds-info-grid__item">
              <span class="ds-info-grid__label">{{ $t('ownerDetail.creator') }}</span>
              <span class="ds-info-grid__value">{{ ownerDetailInfo.userName || '-' }}</span>
            </div>
            <div class="ds-info-grid__item ds-info-grid__item--wide">
              <span class="ds-info-grid__label">{{ $t('ownerDetail.remark') }}</span>
              <span class="ds-info-grid__value">{{ ownerDetailInfo.remark || '-' }}</span>
            </div>
            <div class="ds-info-grid__item" v-for="(item, index) in ownerDetailInfo.ownerAttrDtos" :key="index">
              <span class="ds-info-grid__label">{{ item.specName }}</span>
              <span class="ds-info-grid__value">{{ item.valueName || '-' }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- (3) 业务标签页面板 -->
    <div class="ds-panel ds-panel--tabs">
      <el-tabs v-model="ownerDetailInfo._currentTab" @tab-click="changeTab(ownerDetailInfo._currentTab)">
        <el-tab-pane :label="$t('ownerDetail.room')" name="ownerDetailRoom"></el-tab-pane>
        <el-tab-pane :label="$t('ownerDetail.car')" name="ownerDetailCar"></el-tab-pane>
        <el-tab-pane :label="$t('ownerDetail.member')" name="ownerDetailMember"></el-tab-pane>
        <el-tab-pane :label="$t('ownerDetail.history')" name="ownerDetailHis"></el-tab-pane>
        <el-tab-pane :label="$t('ownerDetail.roomFee')" name="ownerDetailRoomFee"></el-tab-pane>
        <el-tab-pane :label="$t('ownerDetail.paymentHistory')" name="ownerDetailHisFee"></el-tab-pane>
        <el-tab-pane :label="$t('ownerDetail.account')" name="ownerDetailAccount"></el-tab-pane>
        <el-tab-pane :label="$t('ownerDetail.coupon')" name="ownerDetailCoupon"></el-tab-pane>
        <el-tab-pane :label="$t('ownerDetail.ownerBinding')" name="ownerDetailAppUser"></el-tab-pane>
        <el-tab-pane :label="$t('ownerDetail.complaint')" name="ownerDetailComplaint"></el-tab-pane>
        <el-tab-pane :label="$t('ownerDetail.repair')" name="ownerDetailRepair"></el-tab-pane>
        <el-tab-pane :label="$t('ownerDetail.visitor')" name="ownerDetailVisit"></el-tab-pane>
        <el-tab-pane :label="$t('ownerDetail.contract')" name="ownerDetailContract"></el-tab-pane>
        <el-tab-pane :label="$t('ownerDetail.receipt')" name="ownerDetailReceipt"></el-tab-pane>
        <el-tab-pane :label="$t('ownerDetail.depositReceipt')" name="ownerDetailAccountReceipt"></el-tab-pane>
        <el-tab-pane :label="$t('ownerDetail.faceSync')" name="ownerDetailAccessControl"></el-tab-pane>
        <el-tab-pane :label="$t('ownerDetail.accessRecord')" name="ownerDetailAccessControlRecord"></el-tab-pane>
        <el-tab-pane :label="$t('ownerDetail.chargeOrder')" name="ownerDetailChargeMachineOrder"></el-tab-pane>
      </el-tabs>
    </div>

    <component :is="ownerDetailInfo._currentTab" ref="currentTabComponent"></component>

    <edit-owner ref="editOwner" @refresh="loadOwnerInfo"></edit-owner>
    <delete-fee ref="deleteFee"></delete-fee>
    <edit-fee ref="editFee"></edit-fee>
    <!-- <finish-fee ref="finishFee"></finish-fee> -->
  </div>
</template>

<script>
import OwnerDetailRoom from '@/components/owner/ownerDetailRoom'
import OwnerDetailCar from '@/components/owner/ownerDetailCar'
import OwnerDetailMember from '@/components/owner/ownerDetailMember'
import OwnerDetailHis from '@/components/owner/ownerDetailHis'
import OwnerDetailAccount from '@/components/owner/ownerDetailAccount'
import OwnerDetailCoupon from '@/components/owner/ownerDetailCoupon'
import OwnerDetailAppUser from '@/components/owner/ownerDetailAppUser'
import OwnerDetailComplaint from '@/components/owner/ownerDetailComplaint'
import OwnerDetailRepair from '@/components/owner/ownerDetailRepair'
import OwnerDetailVisit from '@/components/owner/ownerDetailVisit'
import OwnerDetailContract from '@/components/owner/ownerDetailContract'
import OwnerDetailRoomFee from '@/components/owner/ownerDetailRoomFee'
import OwnerDetailHisFee from '@/components/owner/ownerDetailHisFee'
import OwnerDetailReceipt from '@/components/owner/ownerDetailReceipt'
import OwnerDetailAccountReceipt from '@/components/owner/ownerDetailAccountReceipt'
import OwnerDetailAccessControl from '@/components/owner/ownerDetailAccessControl'
import OwnerDetailAccessControlRecord from '@/components/owner/ownerDetailAccessControlRecord'
import OwnerDetailChargeMachineOrder from '@/components/owner/ownerDetailChargeMachineOrder'
import EditOwner from '@/components/owner/editOwner'
import DeleteFee from '@/components/fee/deleteFee'
import EditFee from '@/components/fee/editFee'
//import FinishFee from '@/components/fee/finishFee'
import { getCommunityId } from '@/api/community/communityApi'
import { queryOwners } from '@/api/owner/ownerDetailApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'

export default {
  name: 'OwnerDetail',
  components: {
    OwnerDetailRoom,
    OwnerDetailCar,
    OwnerDetailMember,
    OwnerDetailHis,
    OwnerDetailAccount,
    OwnerDetailCoupon,
    OwnerDetailAppUser,
    OwnerDetailComplaint,
    OwnerDetailRepair,
    OwnerDetailVisit,
    OwnerDetailContract,
    OwnerDetailRoomFee,
    OwnerDetailHisFee,
    OwnerDetailReceipt,
    OwnerDetailAccountReceipt,
    OwnerDetailAccessControl,
    OwnerDetailAccessControlRecord,
    OwnerDetailChargeMachineOrder,
    EditOwner,
    DeleteFee,
    EditFee,
    //FinishFee,
    DsPageHeader
  },
  data() {
    return {
      ownerDetailInfo: {
        viewOwnerFlag: '',
        ownerId: "",
        memberId: '',
        name: "",
        age: "",
        sex: "",
        userName: "",
        remark: "",
        idCard: "",
        link: "",
        ownerPhoto: "/img/noPhoto.jpg",
        ownerAttrDtos: [],
        faceUrl: '',
        _currentTab: 'ownerDetailRoom',
        personType: '',
        personTypeName: '',
        personRole: '',
        personRoleName: '',
        concactLink: '',
        concactPerson: '',
        needBack: false
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      this.ownerDetailInfo.ownerId = this.$route.query.ownerId
      this.ownerDetailInfo.needBack = this.$route.query.needBack
      if (!this.ownerDetailInfo.ownerId) {
        return
      }
      const currentTab = this.$route.query.currentTab
      if (currentTab) {
        this.ownerDetailInfo._currentTab = currentTab
      }
      this.loadOwnerInfo()
    },
    loadOwnerInfo() {
      const params = {
        ownerId: this.ownerDetailInfo.ownerId,
        page: 1,
        row: 1,
        communityId: getCommunityId(),
        ownerTypeCd: '1001'
      }

      queryOwners(params).then(response => {
        const data = response.data[0]
        Object.assign(this.ownerDetailInfo, data)
        this.ownerDetailInfo.ownerAttrDtos = data.ownerAttrDtos
        this.changeTab(this.ownerDetailInfo._currentTab)
      }).catch(error => {
        console.error('Failed to load owner info:', error)
      })
    },
    changeTab(tab) {
      this.ownerDetailInfo._currentTab = tab || tab
      setTimeout(() => {
        if (this.$refs.currentTabComponent) {
          if (this.ownerDetailInfo._currentTab == 'ownerDetailRoomFee') {
            this.$refs.currentTabComponent.open({
              ownerId:this.ownerDetailInfo.ownerId,
              name:this.ownerDetailInfo.name,
              link:this.ownerDetailInfo.link
            }
            )
            return;
          }
          this.$refs.currentTabComponent.open(
            this.ownerDetailInfo.ownerId,
            this.ownerDetailInfo.name,
            this.ownerDetailInfo.link
          )
        }
      }, 1000);

    },
    errorLoadImg() {
      this.ownerDetailInfo.ownerPhoto = "/img/noPhoto.jpg"
    },
    _openEditOwnerDetailModel() {
      this.$refs.editOwner.open(this.ownerDetailInfo)
    }
  }
}
</script>

<style lang="scss" scoped>
.owner-detail-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);

  &--padded {
    padding: var(--ds-spacing-lg);
  }

  &--tabs {
    padding: 0 var(--ds-spacing-lg);
  }
}

/* 面板标题栏 */
.ds-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: var(--ds-spacing-md);
  margin-bottom: var(--ds-spacing-lg);
  border-bottom: 1px solid var(--ds-gray-200);
}

.ds-panel__title {
  font-size: var(--ds-font-size-lg);
  font-weight: 600;
  color: var(--ds-gray-800);
}

/* 业主头像 */
.owner-detail-avatar {
  padding-top: var(--ds-spacing-sm);
}

.border-radius {
  border-radius: var(--ds-radius-md);
}
</style>